import React from "react";
import styled from "styled-components";
import { colors } from "../theme/colors";
import { shadows } from "../theme/shadows";

const Badge = ({
  children,
  variant = "info",
  size = "medium",
  className,
  ...props
}) => {
  return (
    <StyledBadge variant={variant} size={size} className={className} {...props}>
      {children}
    </StyledBadge>
  );
};

const StyledBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  border: 1px solid;
  white-space: nowrap;
  box-shadow: ${shadows.sm};

  ${({ size }) => {
    switch (size) {
      case "small":
        return `
          padding: 2px 8px;
          font-size: 0.75em;
          border-radius: 8px;
        `;
      case "large":
        return `
          padding: 8px 16px;
          font-size: 1em;
          border-radius: 16px;
        `;
      default:
        return `
          padding: 4px 12px;
          font-size: 0.8em;
          border-radius: 12px;
        `;
    }
  }}

  ${({ variant }) => {
    switch (variant) {
      case "success":
        return `
          background: ${colors.success.light};
          color: ${colors.success.main};
          border-color: ${colors.success.border};
        `;
      case "error":
        return `
          background: ${colors.error.light};
          color: ${colors.error.main};
          border-color: ${colors.error.border};
        `;
      case "warning":
        return `
          background: ${colors.warning.light};
          color: ${colors.warning.main};
          border-color: ${colors.warning.border};
        `;
      case "info":
        return `
          background: ${colors.info.light};
          color: ${colors.info.main};
          border-color: ${colors.info.border};
        `;
      case "neutral":
        return `
          background: rgba(149, 165, 166, 0.2);
          color: ${colors.neutral[600]};
          border-color: rgba(149, 165, 166, 0.3);
        `;
      case "primary":
        return `
          background: rgba(44, 90, 160, 0.2);
          color: ${colors.primary.main};
          border-color: rgba(44, 90, 160, 0.3);
        `;
      default:
        return `
          background: ${colors.info.light};
          color: ${colors.info.main};
          border-color: ${colors.info.border};
        `;
    }
  }}
`;

export default Badge;
